<template>
  <v-text-field
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    :label="label"
    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    @click:append="show = !show"
    :type="show ? 'text' : 'password'"
    :disabled="disabled"
    :rules="rules.password"
  />
</template>

<script>
export default {
  props: ['label', 'value'],
  data(){
    return {
      disabled: null,
      show: false,
      password: null,
      rules: {
        password: [
          v => (!!v && v.length >= 4) || 'Password is too short...',
        ]
      }
    }
  },
}
</script>